<template>
  <component :is="resolvedLandingPage" />
</template>

<script>
import {mapState} from "vuex";
import LandingPageBLG from "./LandingPageBLG.vue";
import LandingPageFantasy from "./LandingPageFantasy.vue";

const LANDING_PAGE_COMPONENTS = {
  LandingPageBLG,
  LandingPageFantasy,
};

export default {
  computed: {
    ...mapState(['brandConfig']),
    resolvedLandingPage() {
      const landingPage = this.brandConfig?.landingPage;
      return LANDING_PAGE_COMPONENTS[landingPage] || LandingPageFantasy;
    },
  },
}
</script>
